import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FeatureCard as FeatureCardType } from '../../types';

const FeatureCard: React.FC<FeatureCardType> = ({ icon, title, description, actionLabel, path }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: 'var(--surface)',
        border: `1px solid ${hovered ? 'var(--accent)' : 'var(--border)'}`,
        borderRadius: 'var(--radius-lg)',
        padding: 24,
        transition: 'border-color var(--transition-base), transform var(--transition-base)',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
        cursor: 'default',
      }}
    >
      <div style={{ fontSize: 24, marginBottom: 12 }}>{icon}</div>
      <div style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: 4 }}>{title}</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', lineHeight: 1.55 }}>{description}</div>
      <button
        onClick={() => navigate(path)}
        style={{
          marginTop: 16,
          display: 'inline-flex', alignItems: 'center',
          gap: hovered ? 10 : 6,
          fontSize: '0.78rem', fontWeight: 600,
          color: 'var(--accent)',
          background: 'transparent', border: 'none',
          cursor: 'pointer', fontFamily: 'var(--font-sans)',
          padding: 0,
          transition: 'gap var(--transition-base)',
        }}
      >
        {actionLabel} →
      </button>
    </div>
  );
};

export default FeatureCard;
